/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Coze UC BFF 路径（统一入口，业务勿硬编码） */
export const UC_BFF_PATHS = {
  login: '/api/passport/web/uc/login/',
  bridge: '/api/passport/web/uc/bridge/',
  loginAccountInfo: '/api/passport/web/uc/loginAccountInfo/',
  departmentTreeV2: '/api/passport/web/uc/department/tree/v2/',
} as const;
